/** zh-CN catalogue `history` (W3-09; English: src/features/history/history.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'history',
  locale: 'zh-CN',
  messages: {
    panelTitle: '历史',
    listLabel: '更改，最新的在前',
    summary: '{count, plural, other {# 步}} · {memory} · 重新加载后保留（最近 500 次更改）',
    jumpToChange: '撤销和重做时跳转到更改处',
    versionsButton: '版本…',
    truncated: '更早的更改无法在此撤销。',
    seeVersions: '查看版本',
    openedDivider: '上方为本次会话打开后的更改，下方为之前的会话',
    startRow: '这些更改之前',
    noEffect: '没有可见的变化',
    currentSr: '（当前状态）',
    undoneSr: '（已撤销，可重做）',
    justNow: '刚刚',
    emptyTitle: '还没有更改',
    emptyBody: '每次编辑都会出现在这里。单击一项即可回到该处；在你下次编辑之前，后面的条目都会保留。',
    noProjectTitle: '没有打开的谱面',
    noProjectBody: '打开一张谱面以查看其历史。',
    gestureActive: '请先完成当前的拖动。',
    hint: '{undo} 撤销，{redo} 重做。单击一项即可后退或前进到该处。',
    undoButton: '“撤销”按钮',
    redoButton: '“重做”按钮',
    sizeB: '{size} B',
    sizeKB: '{size} KB',
    sizeMB: '{size} MB',
    sizeGB: '{size} GB',
    sizeTB: '{size} TB',
    versionsTitle: '{name} 的版本历史',
    retention:
      'Phiedit 会保留最近一小时内的每个版本、2 天内每小时一个版本、30 天内每天一个版本，以及每个检查点和导出。每编辑 10 分钟，以及在导入、导出、恢复和大型生成器运行之前，都会创建一个版本。',
    versionsListLabel: '版本，最新的在前',
    untitled: '未命名谱面',
    checkpointName: '检查点名称（可选）',
    checkpointPlaceholder: '例如：重做副歌之前',
    createCheckpoint: '创建检查点',
    checkpointCreated: '已创建检查点。',
    checkpointNamed: '已创建检查点“{name}”。',
    notOpenNote: '此谱面未打开。恢复版本时会先打开它。',
    budgetLabel: '版本已使用此谱面 {budget} 配额中的 {used}',
    budgetNote: '超出配额时，最旧的自动版本会被最先移除。检查点和导出总会保留。',
    loading: '正在加载版本…',
    loadFailed: '无法列出版本：{reason}',
    retry: '重试',
    noVersionsTitle: '还没有版本',
    noVersionsBody: 'Phiedit 每编辑 10 分钟会创建一个版本。按 {keys} 可立即创建检查点。',
    noVersionsBodyNoKeys: 'Phiedit 每编辑 10 分钟会创建一个版本。“创建检查点”（在项目菜单中）可立即创建一个。',
    kindAuto: '自动版本',
    kindCheckpoint: '检查点',
    kindImport: '导入之前',
    kindExport: '已导出',
    kindBeforeRestore: '恢复之前',
    kindBeforeGenerator: '生成器运行之前',
    alwaysKept: '始终保留',
    currentState: '当前状态',
    alreadyCurrent: '此版本就是当前状态。',
    restore: '恢复',
    restoreLabel: '恢复 {when} 的 {name}',
    openCopy: '作为副本打开',
    openCopyLabel: '作为副本打开：{when} 的 {name}',
    working: '正在处理…',
    close: '关闭',
    restored: '已恢复 {when} 的“{name}”。撤销可找回你的工作。',
    restoreTxn: '恢复版本：{label}',
    restoreNotOpen: '请打开谱面以恢复其版本。',
    restoreGesture: '请先完成当前的拖动，再恢复版本。',
    copyName: '{name}（{when}）',
    copyCreated: '已从该版本创建“{name}”。',
    lockedElsewhere: '“{name}”已在另一个标签页中打开。请在那里恢复版本，或先在那里关闭它。',
    lockedTitle: '“{name}”已在另一个标签页中打开',
    lockedBody:
      '同一时间只能在一个标签页中编辑谱面，这样两个标签页的更改永远不会混在一起。请在那个标签页中恢复版本，或改为在此处编辑谱面。',
    lockedSwitch: '切换到该标签页',
    lockedSwitchHelp: '在另一个标签页中继续编辑，并在那里恢复版本。',
    lockedHere: '改为在此处编辑',
    lockedHereHelp: '另一个标签页会保存并关闭谱面，然后返回它的谱面库。之后谱面会在此处打开并恢复该版本。',
    lockedSwitched:
      'Phiedit 已请求另一个标签页切换到前台。如果浏览器没有切换，请在标签栏中选择显示“{name}”的 Phiedit 标签页。',
    lockedRefused: '另一个标签页没有交出谱面。请在那里关闭它，然后重试。',
    nameButton: '命名',
    nameButtonLabel: '命名 {when} 的 {name}',
    renameButton: '重命名',
    renameButtonLabel: '重命名 {when} 的 {name}',
    nameField: '此版本的名称',
    nameJustMade: '为刚创建的检查点命名',
    nameSave: '保存名称',
    nameCancel: '取消',
    nameEmpty: '请先输入名称。',
    named: '已将检查点命名为“{name}”。',
    nameNoLonger: '该检查点之后谱面已改变，因此无法再为其命名。请改用“创建检查点”为当前状态命名。',
    nameNotOpen: '请打开谱面以命名其检查点。',
    actionFailed: '操作失败：{reason}',
    cmdCheckpoint: '创建检查点',
    cmdVersions: '版本历史…',
    cmdShow: '显示历史',
    cmdJumpToChange: '撤销和重做时跳转到更改处',
    cmdClear: '清除撤销历史…',
    checkpointToast: '所有更改都会自动保存。已创建检查点。',
    checkpointFailed: '无法创建检查点：{reason}',
    nameIt: '命名',
    cmdNameCheckpoint: '命名检查点…',
    reasonNoProject: '请先打开一张谱面。',
    reasonNothingToClear: '历史为空。',
    clearTitle: '清除撤销历史？',
    clearBody: '{count, plural, other {# 步}}将无法再撤销。谱面本身不会改变，其版本仍然可用。',
    clearConfirm: '清除历史',
    cleared: '已清除撤销历史。',
    helpTitle: '撤销、历史与版本',
    helpBody:
      '你所做的一切更改都可以撤销和重做：使用顶栏或“编辑”菜单中的**撤销**和**重做**（快捷键显示在它们旁边以及“设置 > 键盘”中）。“历史”选项卡列出每一步：单击一步即可后退或前进到该处。历史在重新加载后仍会保留（最近 500 次更改）。\n\n编辑时你的工作会自动保存。**创建检查点**（在项目菜单中，快捷键显示在旁边）会立即添加一个检查点，随后的提示中的**命名**可以为它命名。**版本历史**保存自动版本、检查点和导出：可以恢复其中一个（一个可撤销的步骤）、将其作为单独的谱面打开，或为当前状态的版本命名。',
  },
};

export default catalog;
